import { ADD_ERROR, HIDE_ERROR } from '../Actions/Errors.action';

const defaultState = {
    
};

export const errors = (state = defaultState, action) => {
	const {type, payload} = action; 
    if (!payload) return state;
    switch (type) {
        case ADD_ERROR:
            return {
                ...state,
                ...payload.list,
            };
        case HIDE_ERROR :
            return defaultState;
        default:
            return state;
    }
}